export const STT_PROVIDER_OPTIONS = [
  { value: 'd', label: 'Deepgram Nova 2' },
  { value: 'd3', label: 'Deepgram Nova 3' },
  { value: 'a', label: 'Azure' },
  { value: 'g', label: 'Gemini' },
] as const;

export type SttProviderValue = (typeof STT_PROVIDER_OPTIONS)[number]['value'];

export type VariantConfig = {
  STT_PROVIDER?: SttProviderValue;
  GEMINI_PROMPT?: string;
  GEMINI_MODEL_ARG?: string;
  PROMPT_TEMPLATE_ID?: string;
  PROMPT_TEMPLATE_VARIANT_ID?: string;
  OUTPUT_TEMPLATE_ID?: string;
  OUTPUT_TEMPLATE_VARIANT_ID?: string;
  PROMPT_MODEL_ARG?: string;
};

export type OverrideKey = keyof VariantConfig;

// Specific version constants
export const CONFIG_VERSION_2024_12_19 = '2024-12-19';

// Current version - always points to the latest
export const CURRENT_CONFIG_VERSION = CONFIG_VERSION_2024_12_19;

export type VersionedVariantConfig = {
  version: string;
  publishedAt: string;
  config: VariantConfig;
};
